import { render, staticRenderFns } from "./rejected.vue?vue&type=template&id=7b36cc8d&scoped=true"
import script from "./rejected.vue?vue&type=script&lang=js"
export * from "./rejected.vue?vue&type=script&lang=js"
import style0 from "./rejected.vue?vue&type=style&index=0&id=7b36cc8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36cc8d",
  null
  
)

export default component.exports